import * as LabelPrimitive from '@radix-ui/react-label';
import type { FC, ReactNode } from 'react';

interface FormFieldProps {
  label: string;
  htmlFor: string;
  /** Renders the asterisk convention required by webPanel/CLAUDE.md §4.7. */
  required?: boolean;
  error?: string;
  children: ReactNode;
}

const FormField: FC<FormFieldProps> = ({ label, htmlFor, required, error, children }) => (
  <div className="flex flex-col gap-1.5">
    <LabelPrimitive.Root
      htmlFor={htmlFor}
      className="text-sm font-medium text-[var(--color-ink-muted)]"
    >
      {label}
      {required ? (
        <span className="ml-0.5 text-[var(--color-danger-ink)]" aria-hidden="true">
          *
        </span>
      ) : null}
    </LabelPrimitive.Root>
    {children}
    {error ? <p className="text-xs text-[var(--color-danger-ink)]">{error}</p> : null}
  </div>
);

export default FormField;
